<template>
  <page>
    <template slot="content">
      <help-content :title="'WeBandから計測データを取得する方法'">
        <template slot="content">
          <div class="text">
            1. 携帯電話のBluetoothをオンにします。<br><br>
            2. ホームを下スワイプすると、歩数の上に「データ同期中」と表示されます。
          </div>
          <img class="picture" src="../assets/images/q_and_a/8.png">
          <div class="text">
            3. Bluetoothをオンのままにするとアプリを開くと同時に、データが自動的に同期されます。
          </div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help17.vue